const ARProductComponent = () => ({
  variants: [],
  arAssets: [],
  title: "",
  vendor: "",
  handle: "",
  pageUrl: "",
  dimension_grid: [],
  variantSizes: [],
  selectedVariant: null,
  options: { size: "", frame: "", mount: "" },
  init() {

    const container = this.$el

    this.variants = JSON.parse(container.dataset.arVariants)
    this.arAssets = this.isValidJSON(container.dataset.arAssets) ? JSON.parse(container.dataset.arAssets) : null;
    this.title = container.dataset.title
    this.vendor = container.dataset.vendor
    this.handle = container.dataset.handle
    this.pageUrl = container.dataset.pageUrl
    this.dimension_grid = JSON.parse(container.dataset.dimensionGrid)
    this.swatches = JSON.parse(container.dataset.swatches)

    const urlParams = new URLSearchParams(window.location.search)
    const variantId = urlParams.get("variant")
    const initialVariant = variantId
      ? this.variants.find((v) => v.id === Number(variantId)) || this.variants[0]
      : this.variants[0]

    this.selectedVariant = initialVariant

    this.options = {
      size: initialVariant.option1,
      frame: initialVariant.option2,
      mount: initialVariant.option3,
    }

    this.setVariantsSizes()
  },

 isValidJSON(jsonString) {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (e) {
    return false;
  }
},

  updateVariant() {
    // Find the variant that matches the selected options - need Fix by New logic
    this.selectedVariant =
      this.variants.find(
        (v) =>
          v.option1 === this.options.size &&
          v.option2 === this.options.frame &&
          v.option3 === this.options.mount,
      ) || this.variants[0]


    this.setVariantsSizes();

  },


  setVariantsSizes() {


    const searchOptions = Object.keys(this.dimension_grid)


    if (!this.dimension_grid) {
      return null
    }

    const index = this.findOptionIndex(this.selectedVariant, searchOptions)
    const value = Object.values(this.dimension_grid)[index ? index : 0];

    if (value) {
      this.variantSizes = value;
    }
  },

  findOptionIndex(shopifyVariant, searchOptions) {
    const index = searchOptions.findIndex(option => shopifyVariant.options.includes(option))
    return index === -1 ? false : index
  },

  getCurrentFrameSwatch(name) {
    const current_swatch = this.swatches.find(swatch => swatch.swatch_name === name)

    if (!current_swatch) {
      return ""
    }

    if (current_swatch.swatch_image) {
      return `background-image: url(${current_swatch.swatch_image})`
    } else {
      return `background-color: ${current_swatch.swatch_color}`
    }

  },
  get selectedAR() {
    return (
      this.arAssets.find(
        (a) => a.id === `gid://shopify/ProductVariant/${this.selectedVariant?.id}`,
      ) || this.arAssets[0]
    )
  },

  isMobile() {
    return /iPhone|iPod|iPad|Android/i.test(navigator.userAgent)
  },


  handleARClick() {
    try {
      window.dispatchEvent(
        new CustomEvent("AR Drawer Open", {
          detail: {
            title: this.title,
            variants: this.variants,
            arAssets: this.arAssets,
            vendor: this.vendor,
            handle: this.handle,
          },
        }),
      )
    } catch (error) {
      console.error("Error dispatching 'AR Drawer Open' event:", error)
    }
  },
})

export default ARProductComponent
